app = angular.module("seismology")
ref = firebase.database().ref()
    
app.factory "LevelTable" , ->

  table = require('../data/level_table.json')

  getLevelOf: (points) ->
    index = table.findIndex (level)-> points < level
    index

  pointsInCurrentLevel: (points) ->
    return 0 unless points
    index = table.findIndex (levelPoint)->
      points < levelPoint
    points - table[index-1]

  getLevelPoints: (level) ->
    table[level] - table[level-1]

app.factory "CurrentUserFactory", ($firebaseObject, $firebaseArray, LevelTable, Notification, Admins) ->

  PT_DIAMOND = 100
  PT_LIKE = 300
  PT_CHAR = 1
  
  $firebaseObject.$extend
    update: (data) ->
      promises = (@$ref().child(k).set(v) for k,v of data)
      Promise.all(promises)

    updateGemCount: ->
      ref = firebase.database().ref()      
      progressRef = ref.child('lesson-progress').child(@$id)
      progress= $firebaseArray(progressRef)
      progress.$loaded().then (ary) =>        
        count = 0
        for p in ary
          count += p.$value 
        @update(gemCount: count)        

    updatePoints: ->
      @$loaded =>
        @gemCount ||= 0
        @likesCount ||= 0
        @charCount ||= 0
        points =
          (PT_DIAMOND*@gemCount) + (PT_LIKE*@likesCount) + (PT_CHAR * @charCount)
        @update(points: points)

    updateLevel: ->
      @currentLevel ||= 1
      level = LevelTable.getLevelOf(@points)
      if level > @currentLevel
        @currentLevel = level
        @update(currentLevel: level).then ->
          Notification.levelUp(level)

    isAdmin: ->
      Admins.isAdmin(@$id)
      

app.factory "Admins", ($firebaseArray) ->

  adminsRef = firebase.database().ref().child('/admins')
  admins = $firebaseArray(adminsRef)

  isAdmin: (uid) ->
    admins.$getRecord(uid)?.$value

  # setAdmin: (uid, bool= true) ->
  #   adminsRef.child(uid).set(bool)

app.factory "CurrentUser", ($firebaseObject, $firebaseAuth, CurrentUserFactory) ->

  initUser: ->
    ref = firebase.database().ref()
    uid = $firebaseAuth().$getAuth().uid
    userRef = ref.child('users').child(uid)
    user = new CurrentUserFactory(userRef)
    # watch gem count, char count, points
    gemCount = $firebaseObject(userRef.child('gemCount'))
    charCount = $firebaseObject(userRef.child('charCount'))
    points = $firebaseObject(userRef.child('points'))
    gemCount.$watch (data) =>
      user.updatePoints()
    charCount.$watch ->
      user.updatePoints()
    points.$watch ->
      user.updateLevel()
    user
  
  get: ->
    @user ||= @initUser()
    @user

      
app.factory "UserFactory", ($firebaseObject) ->
  
  $firebaseObject.$extend
    upvote: ->
      usersRef.child(uid+'/likesCount').transaction (current) ->
        (current or 0)+1

app.factory "Users", ($firebaseObject, $firebaseAuth, $firebaseArray, $firebase) ->
  usersRef = ref.child('users')
  cache = {}
  currentUser = null

  update: (uid, data) ->
    user = $firebaseObject(usersRef.child(uid))
    user.name = data.displayName
    user.avatar = data.photoURL
    user.providerId = data.providerId
    user.$save()

  current: ->
    @get($firebaseAuth().$getAuth().uid)

  get: (uid) ->
    if(user = cache[uid])
      user
    else
      user = $firebaseObject(usersRef.child(uid))
      cache[uid] = user
      user

  getCharRanking: (limit=30) ->
    $firebaseArray(usersRef.orderByChild('charCount').limitToLast(limit))

  upvote: (uid)->
    usersRef.child(uid+'/likesCount').transaction (current) ->
      (current or 0)+1

  downvote: (uid)->
    usersRef.child(uid+'/likesCount').transaction (current) ->
      (current or 0)-1

  addCharCount: (count) ->
    uid = $firebaseAuth().$getAuth().uid
    usersRef.child(uid+'/charCount').transaction (current) ->
      (current or 0)+count



app.factory "NotificationList", ($firebaseArray, $state) ->
  $firebaseArray.$extend
    getUnreadCount: ->
      count = 0
      for n in @$list
        count+=1 if !n.read
      count
    jumpToSource: (record)->
      console.log record
      switch record.type
        when 'post_liked'
          $state.go('dashboard.post', post_id: record.post_id)
        when 'comment_liked'
          $state.go('dashboard.post', post_id: record.post_id)
        when 'comment_created'
          $state.go('dashboard.post', post_id: record.post_id)
        when 'discussion_liked'
          $state.go('dashboard.discussion', id: record.discussion_id)
        when 'discussion_comment_liked'
          $state.go('dashboard.discussion', id: record.discussion_id)
        when 'discussion_comment_created'
          $state.go('dashboard.discussion', id: record.discussion_id)
        when 'timeline_event_liked'
          data= id: record.book_id, content: record.content+1
          $state.go('transcription.content.history', data)
        when 'timeline_event_created'
          data= id: record.book_id, content: record.content+1
          $state.go('transcription.content.history', data)
          

app.factory 'AppServer', ($http) ->
  SERVER_URL = "https://wahon-server.herokuapp.com/"
  #SERVER_URL = "http://localhost:4567/"
  

  post: (path, data) ->
    $http
      method: 'post'
      headers: 'Content-Type': 'application/x-www-form-urlencoded'
      url: SERVER_URL + path
      transformRequest: (data) -> $.param(data)
      data: data


app.factory "Notification", ($http, $firebaseArray, $firebaseAuth, NotificationList) ->
  SERVER_URL = "https://wahon-server.herokuapp.com/notifications/"

  post = (url, data) ->
    $http
      method: 'post'
      headers: 'Content-Type': 'application/x-www-form-urlencoded'
      url: url
      transformRequest: (obj) ->
        str = []
        for k, v of data
          str.push(encodeURIComponent(k) + "=" + encodeURIComponent(v))
        str.join("&")
      data: data

  levelUp: (level) ->
    @levelsNotified ||= {}
    console.log @levelsNotified
    return if @levelsNotified[level]
    uid = $firebaseAuth().$getAuth().uid
    url = SERVER_URL + "users/levelup"
    @levelsNotified[level] = true
    post(url, uid: uid)      

  commentCreated: (postId, commentId)->
    url = SERVER_URL + "comments"
    post url, post_id: postId, comment_id: commentId

  postLiked: (postId, userId) ->
    url = SERVER_URL + "likes/post"
    post url, post_id: postId, liker_uid: userId

  commentLiked: (postId, commentId, userId) ->
    url = SERVER_URL + "likes/comment"
    post url, post_id: postId, comment_id: commentId, liker_uid: userId

  discussionCommentCreated: (discussionId, commentId)->
    url = SERVER_URL + "discussions/#{discussionId}/comments"
    post url, comment_id: commentId

  discussionLiked: (discussionId, userId) ->
    url = SERVER_URL + "discussions/#{discussionId}/likes"
    post url, liker_uid: userId

  discussionCommentLiked: (discussionId, commentId, userId) ->
    url = SERVER_URL + "discussions/#{discussionId}/comments/#{commentId}/likes"
    post url, liker_uid: userId

  timelineEventLiked: (eventId) ->
    url = SERVER_URL + "timeline/#{eventId}/likes"
    post url, liker_uid: $firebaseAuth().$getAuth().uid

  timelineEventCreated: (eventId, predesessorIds)->
    url = SERVER_URL + "timeline/#{eventId}"
    post url, predesessorIds: predesessorIds.join(',')
    console.log predesessorIds.join(',')

  getList: (limit=20)->
    uid = $firebaseAuth().$getAuth().uid
    ref = firebase.database().ref().child('notifications').child(uid)
    query = ref.orderByChild('rtimestamp').limitToFirst(limit)
    new NotificationList(query)

  getUnread: (limit=20)->
    uid = $firebaseAuth().$getAuth().uid
    ref = firebase.database().ref().child('notifications').child(uid)
    query = ref.orderByChild("read").equalTo(false).limitToFirst(limit)
    $firebaseArray(query)

app.factory "DesktopNotification", ($http, $window, CurrentUser, AppServer, VAPID_PUBLIC_KEY) ->
        
  registerServiceWorker: ->
    $window.navigator.serviceWorker.register('push.js')

  requestPermission: ->
    $window.Notification.requestPermission()

  subscribePush: ->
    $window.navigator.serviceWorker.ready.then (sw)->
      opts = userVisibleOnly: true, applicationServerKey: VAPID_PUBLIC_KEY.ARRAY
      sw.pushManager.subscribe(opts)
    
  getSubscription: ->
    $window.navigator.serviceWorker.ready.then (sw)->
      sw.pushManager.getSubscription()

  sendSubscriptionToServer: (subscription) ->
    AppServer.post(subscription)

  checkNotificationSupport: ->
    notificationSupport = $window.Notification
    workerSupport = $window.navigator && $window.navigator.serviceWorker
    notificationSupport and workerSupport

  enableNotification: ->    
    @registerServiceWorker()
    .then =>
      @subscribePush()
    .then =>
      @getSubscription()
    .then (subscription)=>
      data =
        subscription: subscription.toJSON()
        uid: CurrentUser.get().$id
      AppServer.post('push/subscribe', data)
    .then =>
      @requestPermission()



// WEBPACK FOOTER //
// ./app/services/user_services.coffee